export const FLAG_CDN_URL =
    process.env.REACT_APP_FLAGS_CDN || 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.1/flags/4x3/';
export const DEFAULT_COUNTRY_ID = 236;
export const DEFAULT_COUNTRY_NAME = 'United States';
export const DEFAULT_COUNTRY_CALLING_ID = 184;
